import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProjectsSection = () => {
  const navigate = useNavigate();
  const items = [
    {
      title: "Contactless Water Dispenser",
      type: "Product",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 7l4-4m0 0l4 4m-4-4v18" />
        </svg>
      ),
      desc: "Touchless IR-based dispenser—hygienic, reliable, low-power.",
    },
    {
      title: "Smart Energy Monitoring System",
      type: "Future Project",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      desc: "Real-time metering with alerts, reports, and cloud sync.",
    },
    {
      title: "Smart Facility Monitoring System",
      type: "Future Project",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-8m-8 0H3m2 0h2M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      desc: "Environment, access & assets in one dashboard with automation.",
      subProducts: ["Smart Dustbin Monitoring System", "Indoor Air Quality Monitoring System", "Occupancy Counting System"],
    },
    {
      title: "IoT Automation Gateways",
      type: "Future Project",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
      ),
      desc: "Multi-protocol edge hub with secure OTA and APIs.",
    },
  ];

  const [filter, setFilter] = useState("All");
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size for responsive adjustments
  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 768);
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const filtered = useMemo(
    () => (filter === "All" ? items : items.filter((x) => x.type === filter)),
    [filter, items]
  );

  return (
    <section id="products" className="py-5" style={{ background: "var(--canvas)" }} aria-labelledby="projects-heading">
      <div className="container  ">
        {/* Header */}
        <div className="text-center mb-5 section-header">
          <span
            className="badge rounded-pill px-3 py-2 mb-2"
            style={{
              background: "var(--chip)",
              color: "var(--chiptext)",
              border: "1px solid var(--cardborder)",
            }}
          >
            What We Build
          </span>
          <h2 id="projects-heading" className="display-6 display-md-5 fw-bold mb-3" style={{ color: "var(--secondarytext)" }}>
            Our Products
          </h2>
          <div className="divider mx-auto mb-4"></div>
          <p className="mt-3 lead mb-0 mb-md-4" style={{ color: "var(--secondarytext)", opacity: 0.8 }}>
            Practical hardware. Clean design. Built to scale.
          </p>
        </div>

        {/* Filter */}
       {/* <div className="d-flex justify-content-center mb-5">
          <div className="nav nav-pills flex-nowrap flex-md-wrap justify-content-center" role="tablist" aria-label="Project filter">
            {["All", "Product", "Future Project"].map((tab) => {
              const active = filter === tab;
              return (
                <div className="nav-item me-2 mb-2" key={tab}>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={active}
                    onClick={() => setFilter(tab)}
                    className="btn rounded-pill px-3 px-md-4 py-2"
                    style={{
                      background: active ? "var(--primary)" : "var(--card)",
                      color: active ? "white" : "var(--secondarytext)",
                      border: active ? "none" : "1px solid var(--cardborder)",
                      boxShadow: active ? "0 4px 12px rgba(1, 62, 251, 0.25)" : "none",
                      fontWeight: active ? "600" : "400",
                      whiteSpace: "nowrap",
                      fontSize: isMobile ? "0.9rem" : "1rem",
                    }}
                  >
                    {tab}
                  </button>
                </div>
              );
            })}
          </div>
        </div>*/}

        {/* Cards */}
        <div className="row g-4 justify-content-center">
          {filtered.map((it, idx) => (
            <div key={idx} className="col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
              <div
                className="card h-100 product-card border-0"
                style={{
                  background: "var(--card)",
                  borderRadius: "16px",
                  border: "1px solid var(--cardborder)",
                  cursor: (it.title === "Contactless Water Dispenser" || it.title === "Smart Energy Monitoring System" || it.title === "Smart Facility Monitoring System") ? "pointer" : "default",
                }}
                onClick={() => {
                  if (it.title === "Contactless Water Dispenser") {
                    navigate("/products/contactless-water-dispenser");
                  } else if (it.title === "Smart Energy Monitoring System") {
                    navigate("/products/smart-energy-monitoring-system");
                  } else if (it.title === "Smart Facility Monitoring System") {
                    navigate("/products/smart-facility-monitoring-system");
                  }
                }}
              >

                <div className="card-body d-flex flex-column text-center p-4 p-md-4 p-lg-4">
                  {/* Icon */}
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-3 mb-4 icon-container mx-auto"
                    style={{
                      width: "64px",
                      height: "64px",
                      background: "var(--chip)",
                      color: "var(--primary)",
                      flexShrink: 0,
                    }}
                  >
                    {it.icon}
                  </div>

                  {/* Type badge */}
                  <span
                    className="badge rounded-pill px-3 py-2 mb-3"
                    style={{
                      background: "var(--chipalt)",
                      color: "var(--chiptext)",
                      fontSize: "0.75rem",
                    }}
                  >
                    {it.title}
                  </span>

                  {/* Title 
                  <h3 className="h5 mb-3 flex-grow-0" style={{ color: "var(--secondarytext)" }}>
                    {it.title}
                  </h3>*/}

                  {/* Description */}
                  <p className="mb-0 flex-grow-0" style={{ color: "var(--secondarytext)", opacity: 0.8, fontSize: "0.95rem" }}>
                    {it.desc}
                  </p>
                  
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* No results message */}
        {filtered.length === 0 && (
          <div className="text-center py-5">
            <p style={{ color: "var(--secondarytext)", opacity: 0.7 }}>
              No projects found for this filter.
            </p>
          </div>
        )}

        {/* Styles */}
        <style>{`
          .product-card {
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
            transition: all 0.3s ease;
          }
          .product-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 16px 40px rgba(0, 0, 0, 0.1);
            border-color: var(--primary) !important;
          }
          .product-card:hover .icon-container {
            background: var(--primary) !important;
            color: white !important;
            transform: scale(1.05);
          }
          .icon-container {
            transition: all 0.3s ease;
          }
          @media (max-width: 768px) {
            .display-md-5 {
              font-size: 2.5rem;
            }
          }
          @media (prefers-reduced-motion: reduce) {
            .product-card, .icon-container { 
              transition: none; 
            }
            .product-card:hover {
              transform: none;
            }
          }
        `}</style>
      </div>
    </section>
  );
};

export default ProjectsSection;